// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b03e3c98","456":"ad923a8c","507":"1806e1e4"}[chunkId] + ".chunk.js";
};